import React from 'react';
import { X, Check } from 'lucide-react';
import { useLang } from '../../core/lang.jsx';
import LangKeys from '../../core/locales/keys';

const GST_RATES = [
  { label: "Tax Exempted", value: "Tax Exempted", desc: "Items not taxable" },
  { label: "0%", value: "0%", desc: "No GST" },
  { label: "0.1%", value: "0.1%", desc: "0.05% CGST + 0.05% SGST" },
  { label: "0.25%", value: "0.25%", desc: "0.125% CGST + 0.125% SGST" },
  { label: "3%", value: "3%", desc: "1.5% CGST + 1.5% SGST" },
  { label: "5%", value: "5%", desc: "2.5% CGST + 2.5% SGST" },
  { label: "6%", value: "6%", desc: "3% CGST + 3% SGST" },
  { label: "7.5%", value: "7.5%", desc: "3.75% CGST + 3.75% SGST" },
  { label: "12%", value: "12%", desc: "6% CGST + 6% SGST" },
  { label: "18%", value: "18%", desc: "9% CGST + 9% SGST" },
  { label: "28%", value: "28%", desc: "14% CGST + 14% SGST" },
];

const GstPickerModal = ({ isOpen, onClose, onSelect, selectedValue }) => {
  const { t } = useLang();

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <h3 style={styles.title}>{t(LangKeys.add_gst_rate)}</h3>
          <button style={styles.closeBtn} onClick={onClose}><X size={20} /></button>
        </div>

        <div style={styles.list}>
          {GST_RATES.map(rate => (
            <div 
              key={rate.value} 
              style={{...styles.item, backgroundColor: selectedValue === rate.value ? '#F0F9FF' : 'transparent'}} 
              onClick={() => { onSelect(rate.value); onClose(); }}
            >
              <div style={styles.itemInfo}>
                <span style={styles.itemLabel}>{rate.label}</span>
                <span style={styles.itemDesc}>{rate.desc}</span>
              </div>
              {selectedValue === rate.value && <Check size={20} color="#3B82F6" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000 },
  modal: { width: '420px', backgroundColor: '#FFF', borderRadius: '24px', display: 'flex', flexDirection: 'column', maxHeight: '80vh', overflow: 'hidden' },
  header: { padding: '20px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontSize: '18px', fontWeight: '800', color: '#1D4ED8', margin: 0 },
  closeBtn: { border: 'none', background: 'none', color: '#64748B', cursor: 'pointer' },
  list: { flex: 1, overflowY: 'auto', padding: '12px' },
  item: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderRadius: '16px', cursor: 'pointer', transition: 'all 0.2s', marginBottom: '4px' },
  itemInfo: { display: 'flex', flexDirection: 'column', gap: '2px' },
  itemLabel: { fontSize: '15px', fontWeight: '700', color: '#1E293B' },
  itemDesc: { fontSize: '12px', color: '#94A3B8', fontWeight: '500' },
};

export default GstPickerModal;
